














import { Component, Vue, Prop } from "vue-property-decorator";

@Component({ components: {} })
export default class MainNavButton extends Vue {
  @Prop() readonly to!: { name: string };
  @Prop() readonly bgImgSrc!: string;
  @Prop() readonly iconImgSrc!: string;
  @Prop() readonly title!: string;
}
